export default __webpack_public_path__ + "static/media/propertysize.dfaa74a5.svg";